if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.sizeSwatch = this.querySelectorAll('input[data-quick-add="true"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        if (this.sizeSwatch) {
          this.sizeSwatch.forEach((el) => {
            el.addEventListener('click', () => {              
              this.sizeSwatch.forEach(item => item.classList.remove('selected'));
              el.classList.add('selected')
              if(el.classList.contains('sold-out')){                
                this.querySelector('.BIS_trigger').click();
                setTimeout(() => {                
                  this.sizeSwatch.forEach(item => item.classList.remove('selected'));
                }, 500); 
              } else {
                setTimeout(() => {                
                  this.submitButton.click()
                  setTimeout(() => {                
                    this.sizeSwatch.forEach(item => item.classList.remove('selected'));
                  }, 500);   
                }, 1000);              
              }              
            });
          });
        }
        

        if (window.innerWidth <= 768) {
          this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
        }
      }

      connectedCallback() {
        const variantSelectorModule = document.querySelector('.pdp-size-selector__wrapper');

        if (variantSelectorModule) {
          const overlay = variantSelectorModule.querySelector('.overlay');
          if (overlay) {
            overlay.addEventListener('click', () => {
              variantSelectorModule.classList.remove('active');
            });
          }
        }

        if (this.submitButton && this.submitButton.hasAttribute("desktop-disabled")) {
          if (window.innerWidth > 768) {
            this.submitButton.disabled = true;
          } else {
            this.submitButton.disabled = false;
          }
        }
      
        window.addEventListener("resize", () => {
          if (this.submitButton && this.submitButton.hasAttribute("desktop-disabled")) {
            if (window.innerWidth > 768) {
              this.submitButton.disabled = true;
            } else {
              this.submitButton.disabled = false;
            }
          }
        });
      }
      

      handleMobileSubmit(evt) {
        evt.preventDefault();

        const variantSelectorModule = document.querySelector('.pdp-size-selector__wrapper');
        const sizeSelect = variantSelectorModule.querySelectorAll('input.variant-option');        
      
        if (variantSelectorModule) {
          variantSelectorModule.classList.add('active');
          sizeSelect.forEach((el) => {
            el.addEventListener('click', () => {
              setTimeout(() => {
                this.handleVariantAddition(evt, el);
                
                // Close the variant selector by removing 'active' class
                variantSelectorModule.classList.remove('active');
      
                // Uncheck the variant
                el.checked = false;
              }, 1000);
            });
          });
        }
      }
      
      handleVariantAddition(evt, el = null) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').removeAttribute('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (el) {
          const variantID = document.querySelector('input[name="id"]').value;
          formData.append('id', variantID);
        }        

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const formDataValues = [...formData.entries()];


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {

              if (response.status === 422 && document.body.classList.contains('template-product')) {
                if (window.innerWidth > 768) {
                  this.submitButton.disabled = true;
                  this.submitButton.setAttribute('aria-disabled', true);
                }
                console.error("Cannot add more items to the cart.");
                const errorMessage = document.createElement('p');
                errorMessage.classList.add('error-message');
                errorMessage.textContent = "No more available stock for the selected variant.";
                this.form.prepend(errorMessage);
                return;
              }

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
            this.submitButton.querySelector('span').textContent = 'Added to Bag';            
            
            if (this.closest('.product-card')) {
              this.closest('.product-card').classList.add('item-added');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally((response) => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').setAttribute('hidden', '');
          });
      }

      onSubmitHandler(evt) {

        //check if any elements on page conatina data-giftcard attribute
        const giftCard = document.querySelectorAll('[data-giftcard]');
        if (window.innerWidth <= 768 && document.body.classList.contains('template-product') && !giftCard.length) {
          this.handleMobileSubmit(evt);
          return;
        }
      
        this.handleVariantAddition(evt);

      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}